import { Pipe, PipeTransform } from '@angular/core';
import { EAnnouncementRespondButtonText } from '@backend/models/types/announcement';

@Pipe({
  name: 'announcementRespondButtonText',
  standalone: true
})
export class AnnouncementRespondButtonTextPipe implements PipeTransform {
  public transform(respondButtonText: EAnnouncementRespondButtonText): string {
    switch (respondButtonText) {
      case EAnnouncementRespondButtonText.RESPOND:
        return 'Respond';
      case EAnnouncementRespondButtonText.REPORT_ISSUE:
        return 'Report Issue';
      default:
        return 'Share Feedback';
    }
  }
}
